import dayjs from "dayjs";
import React from "react";

import "./FooterMinView.scss";

export default class FooterMinView extends React.Component<any, any> {
	[key: string]: any;
	static defaultProps: any;
	static propTypes: any;
	constructor(props) {
		super(props);

		this.state = {
			currentYear: dayjs().format("YYYY"),
		};
	}
	render() {
		return (
			<div id="footerMin" className="aliC font12">
				© {this.state.currentYear} WeVideo, Inc.&nbsp;&nbsp;|&nbsp;&nbsp;
				<a href="/terms-of-use" target="_blank" rel="noopener">
					Terms of Use
				</a>
				&nbsp;&nbsp;|&nbsp;&nbsp;
				<a href="/privacy" target="_blank" rel="noopener">
					Privacy Policy
				</a>
			</div>
		);
	}
}
